import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import './App.css';

import axios from 'axios';
import NeuronView from './NeuronView';


function Neuronpage() {
	const { neuronId, neuronName, sign } = useParams();

    const [neuronData, setNeuronData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const get_file = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get('https://transluce--neuron-data-server-fastapi-app.modal.run/read_specific_file', {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    params: {
                        layer: neuronId,
                        neuron: neuronName,
                        sign: sign
                    }
                });
                setNeuronData(response.data);
                console.log(response.data);
            } catch (error) {
                console.error('Error fetching file list:', error);
                setNeuronData(null);
            }
            setIsLoading(false);
        }
        get_file();
    }, []);

      return (
        <div className="App">
            {neuronData ? (
              <NeuronView neuronData={neuronData} isNegative={sign === "-"} />
            ) : (
              <div>
                {isLoading ? (
                  <div>Loading...</div>
                ) : (
                  <div>Data for this neuron is not available :(</div>
                )}
              </div>
            )}
        </div>
      );
}

export default Neuronpage;
